import ExerciseList from './ExerciseList';

export default ExerciseList;
